import { TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { BaseTablePropsType } from "../../../types/container.type";
import { formatDate } from "../../../helpers/dateFormatter";
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";

export const VaultTransactionsTable: React.FC<BaseTablePropsType> = ({ rows }) => {
    const vaultTransactionsTableHeaders = ["Date & Time", "Description", "Transaction Type", "Amount"];
    return (
        <BaseTable
            headers={vaultTransactionsTableHeaders}
        >
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow
                            key={index}
                        >
                            <TableCell>{formatDate(row?.createdAt, true)}</TableCell>
                            <TableCell>
                                {row?.description?.split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                            </TableCell>
                            <TableCell>
                                {row?.entryType?.split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                            </TableCell>
                            <TableCell>{formatAmountDisplay(row?.amount ?? 0)}</TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}